var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$props.tag,{tag:"component",staticClass:"secondary-items"},[_vm._l((_vm.$props.items),function(item,index){return [_vm._t("default",[_c('Item',{key:index,attrs:{"item":item}})],{"item":item})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }